import { company, customerData } from '../../utilities/CustomerData'
import { formatPhoneNumber, getPartOfDay } from '../../utilities/extensions'

import stageHistoryIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/stageHistoryIcon.png'
import documentsCenterIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/documentsCenterIcon.png'
import resourceCenterIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/resourceCenterIcon.png'
import qaIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/q&aIcon.png'
import contactUsIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/contactUsIcon.png'
import calenderIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/calenderIcon.png'
import discountIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/discountIcon.png'

export default function DashboardSidePanel({ activeTab, setActiveTab }) {
  const getTabClasses = (tabIndex, haveMargin) => {
    let baseClasses = `flex w-full h-12 p-2 rounded-md items-center cursor-pointer transition-colors duration-300 ${haveMargin && 'mb-4'}`
    let hoverClasses = tabIndex % 2 === 0 ? 'hover:bg-primaryColor hover:bg-opacity-50 hover:text-white' : 'hover:bg-secondaryColor hover:bg-opacity-25 hover:text-white'
    if (activeTab === tabIndex) {
      return `${baseClasses} ${tabIndex % 2 === 0 ? 'bg-primaryColor text-white' : 'bg-secondaryColor text-white'} font-bold bg-opacity-50`
    } else {
      return `${baseClasses} ${hoverClasses}`;
    }
  }

  return (
    <div className='lg:w-1/3 w-11/12 max-sm:hidden'>
      <div className='shadow-full rounded-xl w-full p-5 bg-white'>
        <p className='text-lg font-bold'>{getPartOfDay()}</p>
        <p className='text-3xl font-bold mb-10'>{customerData.customerLeadData.leadContact.contactName}</p>
        <div className='w-full flex flex-row items-center justify-between mb-4'>
          <p className='text-gray-700'>Email:</p>
          <p className='text-gray-500'>{customerData.customerLeadData.leadContact.contactEmail}</p>
        </div>
        <div className='w-full flex flex-row items-center justify-between mb-20'>
          <p className='text-gray-700'>Phone:</p>
          <p className='text-gray-500'>{formatPhoneNumber(customerData.customerLeadData.leadContact.contactPhone)}</p>
        </div>
        <div className='flex flex-col w-full'>
          <div onClick={() => { setActiveTab(0); document.title = `${company.companyName} | Stage History` }} className={getTabClasses(0, true)}>
            <img className='h-full mr-5' src={stageHistoryIcon} alt='Stage History Icon' />
            <p>Stage History</p>
          </div>
          <div onClick={() => { setActiveTab(1); document.title = `${company.companyName} | Document Center` }} className={getTabClasses(1, true)}>
            <img className='h-full mr-5' src={documentsCenterIcon} alt='Documents Center Icon' />
            <p>Document Center</p>
          </div>
          <div onClick={() => { setActiveTab(2); document.title = `${company.companyName} | Resource Center` }} className={getTabClasses(2, true)}>
            <img className='h-full mr-5' src={resourceCenterIcon} alt='Resource Center Icon' />
            <p>Resource Center</p>
          </div>
          <div onClick={() => { setActiveTab(3); document.title = `${company.companyName} | Q&A Center` }} className={getTabClasses(3, true)}>
            <img className='h-full mr-5' src={qaIcon} alt='Q&A Icon' />
            <p>Q&A</p>
          </div>
          {!customerData.customerInvoiceData.invoiceId && (
            <div onClick={() => { setActiveTab(7); document.title = `${company.companyName} | Discount Code` }} className={getTabClasses(7, true)}>
              <img className='h-full mr-5' src={discountIcon} alt='Discount Code' />
              <p>Discount Code</p>
            </div>
          )}
          <div onClick={() => { setActiveTab(4); document.title = `${company.companyName} | Contact Us` }} className={getTabClasses(4, customerData.customerLeadData.leadStage.leadStageId === '4f1fdb1f-4278-4ff7-bde7-c4cd27c10d06' ? true : false)}>
            <img className='h-full mr-5' src={contactUsIcon} alt='Contact Us Icon' />
            <p>Contact Us</p>
          </div>
          {(customerData.customerLeadData.leadType === 'Leads' || customerData.customerLeadData.leadStage.leadStageId === '4f1fdb1f-4278-4ff7-bde7-c4cd27c10d06') && (
            <div onClick={() => { setActiveTab(6); document.title = `${company.companyName} | Change Days` }} className={getTabClasses(6)}>
              <img className='h-full mr-5' src={calenderIcon} alt='Refer A Friend' />
              <p>Change Days</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

/**
 * <div onClick={() => { setActiveTab(5); document.title = 'SETC Pros | Friend Referral Program'}} className={getTabClasses(5)}>
            <img className='h-full mr-5' src={referAFriend} alt='Refer A Friend' />
            <p>Friend Referral Program</p>
          </div>
 */